const DEFAULT_API_BASE_URL = "http://localhost:4002";
const DEFAULT_PRODUCTION_API_BASE_URL = "https://lunarsenterprises.com:4002";

const envApiBaseUrl =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PRODUCTION_API_BASE_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      DEFAULT_PRODUCTION_API_BASE_URL
    : process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

export const API_BASE_URL = envApiBaseUrl.replace(/\/$/, "");
